/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react";
import Header1 from "ui/kit/typography/Header1";
import UsePollPlaySteps from "ui/feature/root/play/UsePollPlaySteps";
import {State} from "ui/feature/root/FormReducer";
import Body from "ui/kit/typography/Body";
import Button from "ui/kit/buttons/Button";
import {Link} from "react-router-dom";
import {PlayPiece} from "constants/paths";
import UsePlayAvailable from "ui/feature/root/play/UsePlayAvailable";
import CompletePreviousStepsSection from "ui/feature/root/common/CompletePreviousStepsSection";

interface Props {
    state: State
}

const PlayWorkspace: React.FC<Props> = ({state}) => {

    const playAvailable = UsePlayAvailable(state);
    const isStatusComplete = UsePollPlaySteps(state);

    if (!playAvailable) {
        return <CompletePreviousStepsSection />;
    }

    if (isStatusComplete) {
        return (
            <div>
                <Header1>Play your music</Header1>
                <Body>Processing complete. You can now use your piece</Body>
                <Link to={PlayPiece(state.pieceId || "")}><Button title={"Play, Listen, Download"}/></Link>
            </div>
        );
    } else {
        return (
            <div>
                <Header1>Loading...</Header1>
                <Body>Once the piece is done processing, you will be able to play and listen to the piece.</Body>
            </div>
        );
    }
}

export default PlayWorkspace;
